import { selectionToSpans } from './selection-to-span';
import { EvidenceType } from '../../enums';
import { mergeSpans, pruneSpans, clone } from './activation-utils';

const activationProcessor = (
  selection: CMxCommonApp.ChargeSessionSelection,
  passedPanel: CMxCommonApp.PanelActivations,
  passedProperty: CMxCommonApp.PropertyActivations,
  passedSpans: CMxCommonApp.SpanActivations
) => {
  const panel = clone<CMxCommonApp.PanelActivations>(passedPanel);
  const property = clone<CMxCommonApp.PropertyActivations>(passedProperty);

  // spans are a bit different, the SpanActivation map will be built from the
  // selection, and then we'll run merge to add and prune to remove.
  const existingSpanActivations = clone<CMxCommonApp.SpanActivations>(
    passedSpans
  );
  const newSpanActivations = selectionToSpans(selection);
  let spans: CMxCommonApp.SpanActivations;

  const action = selection.selectionState;
  const { evidence } = selection;

  if (action.visible) {
    // we are in add or update mode
    // 1. update panel activations
    evidence.forEach(singular => {
      panel[singular.hash] = action;
    });
    // 2. update data activations
    evidence.forEach(singular => {
      // separate out partials from completes
      // completes will populate dataActivations
      if (singular.featureType === EvidenceType.COMPLETE) {
        if (!Array.isArray(property[singular.fieldName])) {
          property[singular.fieldName] = [];
        }
        const evidence = { ...singular, selectionState: action };
        const data = property[singular.fieldName].filter(
          item => item.hash !== evidence.hash
        );
        evidence.meta = evidence.meta ?? {};
        evidence.meta.codeType = `${selection.chargeSessionCode.codeType}`.toLowerCase();
        evidence.meta.provenance = `${selection.chargeSessionCode.provenance}`.toLowerCase();
        data.push(evidence);
        property[singular.fieldName] = data;
      }
    });
    // 3. partials will populate spanActivations
    spans = mergeSpans(existingSpanActivations, newSpanActivations);
  } else {
    // we are in removal mode
    // 1. remove panel activations
    evidence.forEach(singular => {
      delete panel[singular.hash];
    });
    // 2. remove data activations
    evidence.forEach(singular => {
      const activations = property[singular.fieldName] ?? [];
      const data = activations.filter(item => item.hash !== singular.hash);
      if (data.length) {
        property[singular.fieldName] = data;
      } else {
        delete property[singular.fieldName];
      }
    });

    spans = pruneSpans(existingSpanActivations, newSpanActivations);
  }

  return { panel, property, spans };
};

export { activationProcessor };
